import { IOperationColumn } from '../models/vessel-kpi'

export const initOperationColumn = (): IOperationColumn => ({
  hasInbound: true,
  hasOutbound: true,
  hasRestow: true,
})
